export default "__VITE_ASSET__bbb2a9a2__"